import DynamicFieldsGrid from './DynamicFieldsGrid';

export default function SellerClosingCosts({ fields = [], control, FloatingInput, cleanNumber, parentName = null, salesPrice, getValues, setValue }) {
  // Enforce that list inputs come from a useFieldArray (parentName must be provided).
  if (!parentName) {
    // Don't fall back to legacy `formData` arrays for editable inputs — safer to render nothing and
    // ensure the parent wires the fieldArray correctly.
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('SellerClosingCosts: parentName not provided — expected useFieldArray-backed fields. Component will not render editable inputs.');
    }
    return null;
  }

  return <DynamicFieldsGrid fields={fields} control={control} FloatingInput={FloatingInput} cleanNumber={cleanNumber} parentName={parentName} salesPrice={salesPrice} getValues={getValues} setValue={setValue} />;
}
